import { Box } from "@material-ui/core"
import React from "react"
import { useSelector } from "react-redux"
import Header from "../Header"
const AuthLayout = ({ children, classes }) => {
  const { menuMobileClasses, searchClasses } = useSelector(state => ({
    menuMobileClasses: state.common.menuMobileClasses,
    searchClasses: state.common.searchClasses,
  }))
  return (
    <Box
      component="div"
      className={
        "hbku-wrapper hbku-horizontal-nav" + menuMobileClasses + searchClasses
      }
    >
      <Header />
      <Box component="div" className="hbku-pg-wrapper">
        {children}
      </Box>
    </Box>
  )
}

export default AuthLayout
